import React, { useEffect } from "react";
import ReactGA from "react-ga";
import "./App.css";
import { HomePage } from "./containers/HomePage";
import { Blog } from "./components/blog";
import { Navbar } from "./components/navbar";
import { Careers } from "./components/careers/Careers.jsx";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import { Footer } from "./components/footer";
import { StaffingPages } from "./containers/StaffingPages/StaffingPages.jsx";
import { StaffingHomepage } from "./components/staffinghomepage/StaffingHomepage";
import { GetFoodNYC } from "./components/getfoodnyc/GetFoodNyc";
import { BlogPosts } from "./components/blogposts/BlogPosts.jsx";

const TRACKING_ID = "UA-242394917-1"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

function App() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} exact />
          <Route path="/Staffing" element={<StaffingHomepage />} />
          <Route path="/getfoodnyc" element={<GetFoodNYC />} exact />
          <Route path="/careers" element={<Careers />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPosts />} />
          <Route path="/:category" element={<StaffingPages />} exact />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
